// @flow
import { Layout } from 'antd';
import React, { useEffect, useState } from 'react';
import connect from 'react-redux/es/connect/connect';
import { handleServerError, postScaConfirmation } from '../../api/Payment';
import BILFooterPSD2 from '../../components/BILFooterPSD2/BILFooterPSD2';
import BILLoader from '../../components/BILLoader/BILLoader';
import BILPageHeader from '../../components/BILPageHeader';
import LanguagePanel from '../../components/LanguagePanel/LanguagePanel';
import PaymentSummary from '../../components/Summary/PaymentSummary';
import {checkUserDevice, scrollToTop} from '../../hooks/useWindowDimensions';
import {savePaymentSuccess} from '../../stores/PaymentSuccessParam/PaymentSuccessParamActions';
import {handleLanguageChange} from '../../utils/LanguageUtils';
import {redirectTo, redirectToScaDevice} from '../../utils/RedirectUtil';
import {
   SCA_REQUIRED, 
   SCA_EXEMPTION_TO_BE_VALIDATED,
   CANCELLATION_SCA_REQUIRED} from '../../constants/StateConstants';
import './index.less';

//// JS MAIN
const Summary = (props) => {

   useEffect(() => {
      scrollToTop(); 
   }, []);

   const { paymentInfo } = props;
   const [isLoading, setLoading] = useState(false);
   const isRunningOnMobile = checkUserDevice();

   if (!isLoading) {
      return (
         <Layout style={{ background: 'none' }}>
            <BILPageHeader
               setLoading={setLoading}
               {...props}
            />
            {isRunningOnMobile ? null :
               <LanguagePanel
                  right={true}
                  onLanguageChange={(lang) => handleLanguageChange(props, lang, setLoading)}
                  {...props}
               />}   
            <PaymentSummary paymentInfo={paymentInfo} /> 
            <BILFooterPSD2
               onClickConfirm={() => handlePaymentConfirmation(props, setLoading)}
               onClickAbort={() => handlePaymentAbort(props, setLoading)}
               continueDefaultEnabled={true}
               {...props}
            />
         </Layout>
      )
   } else {
      return (
         <div className="intl-spinner-container">
            <BILLoader />
         </div>
      )
   }
};

//// JS FUNCTIONS
function handlePaymentConfirmation(props, setLoading) {

   const { language, history, paymentInfo } = props;

   if (paymentInfo.state) {
      executeStategyRedirect(props, setLoading)
   } else {
      handleServerError({ error: "unexpected.error" }, language, history);
   }
}

function executeStategyRedirect(props, setLoading) {

   const { language, history, paymentInfo } = props;

   switch (paymentInfo.state) {
      case SCA_REQUIRED:
      case CANCELLATION_SCA_REQUIRED:
         redirectToScaDevice(props, paymentInfo)
         setLoading(true);
         break;

      case SCA_EXEMPTION_TO_BE_VALIDATED:
         postScaConfirmation(paymentInfo.paymentRef)
            .then(() => redirectTo(history, `/${language}/${paymentInfo.paymentRef}`))
            .catch((error) => handleServerError(error, language, history));
         setLoading(true);
         break;

      default:
         handleServerError({ error: "unexpected.error" }, language, history);
   }
}

function handlePaymentAbort(props, setLoading) {

   const { language, history, savePaymentSuccess } = props;
   setLoading(true);
   savePaymentSuccess('payment.aborted.message')
   redirectTo(history, `/${language}/result?status=success`)
};

//// JS REDUX
const mapStateToProps = (state) => ({
   language: state.intl.locale,
   paymentInfo: state.paymentInfoParam.paymentInfo
});

const mapDispatchToProps = {
   savePaymentSuccess
};

export default connect(mapStateToProps, mapDispatchToProps)(Summary);
